import React from 'react'
import { Watermark } from 'antd'
import usePersistStore from '@/store/persistStore'

const PrimeWatermark = (props: any) => {
  const storeData: any = usePersistStore()
  const loginInfo = storeData?.loginInfo || {}
  return (
    <Watermark
      content={loginInfo.name}
      font={{ fontSize: 20 }}
      gap={[200, 200]}
    >
      {props.children}
    </Watermark>
  )
}

export default PrimeWatermark
